import React from "react";
import Footer from "./Footer";
import NavBar from "./NavBar";
import ScrollToTop from "./ScrollToTop";
import AviationBackground from "./AviationBackground/AviationBackground";

export default function PageLayout({ children }) {
  return (
    <>
      <AviationBackground />
      <ScrollToTop />
      <NavBar />
      <main className="relative z-10 pt-16 min-h-screen flex flex-col">
        {children}
        <Footer />
      </main>
    </>
  );
}
